import React, { useState } from "react";
import "./style.scss";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import LoginComponent from "../../components/Login";
import SignupComponent from "../../components/Signup";

const Login = () => {
  const [activeTab,setActiveTab] = useState('login');


  const activeLoginTab = () =>{
    setActiveTab("login");
  }

  return (
    <div className="login d-flex flex-column w-50 mx-auto">
      <div className="d-flex tabs">
        <Button onClick={() => setActiveTab('login')} className={classNames({'col-6':true,'active':activeTab==='login'})}>Login</Button>
        <Button onClick={() => setActiveTab('signup')} className={classNames({'col-6':true,'active':activeTab==='signup'})}>Signup</Button>
      </div>
      {activeTab === 'login' && <LoginComponent/>}
      {activeTab === 'signup' && <SignupComponent activeLoginTab={activeLoginTab} />}
    </div>
  );
};

export default Login;
